export function unifyStatus(status) {
  return status?.toUpperCase().replace(' ', '_')
}
